export default __webpack_public_path__ + "static/media/insights-empty-gap-analysis.7a8e63f6.svg";